<template>
  <v-container fluid class="sobre-page pa-0">

    <!-- HERO -->
    <div class="sobre-hero">
      <div class="hero-glow" />
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8" class="text-center">
            <div class="sobre-label">NOSSA HISTÓRIA</div>
            <h1 class="sobre-hero-title">
              Feito por quem entende<br>
              <span class="highlight">o transporte de verdade</span>
            </h1>
            <p class="sobre-hero-sub">
              Nascemos em Bela Vista com um propósito simples: levar tecnologia prática
              para quem move o Brasil — o pequeno e médio transportador.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- MISSÃO -->
    <v-container class="py-16">
      <v-row justify="center" align="center">

        <v-col cols="12" md="5" class="mb-8 mb-md-0">
          <div class="missao-card">
            <div class="missao-icon-wrap">
              <v-icon color="#10b981" size="48">mdi-truck-fast-outline</v-icon>
            </div>
            <h2 class="missao-title">Nossa Missão</h2>
            <p class="missao-text">
              Democratizar o acesso à tecnologia para transportadoras de todos os portes,
              oferecendo um sistema simples, intuitivo e poderoso — sem burocracia,
              sem complicação.
            </p>
            <p class="missao-text">
              Acreditamos que o pequeno transportador merece as mesmas ferramentas
              que as grandes empresas têm, com a praticidade que o dia a dia exige.
            </p>
          </div>
        </v-col>

        <v-col cols="12" md="1" class="d-none d-md-block" />

        <v-col cols="12" md="5">
          <v-row>
            <v-col cols="6" v-for="(item, i) in valores" :key="i" class="mb-4">
              <div class="valor-card">
                <v-icon :color="item.cor" size="28" class="mb-2">{{ item.icone }}</v-icon>
                <div class="valor-titulo">{{ item.titulo }}</div>
                <div class="valor-desc">{{ item.desc }}</div>
              </div>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-container>

    <!-- DIVISOR -->
    <v-divider class="page-divider mx-auto" style="max-width:900px" />

    <!-- FUNDADORES -->
    <v-container class="py-16">
      <v-row justify="center" class="mb-10">
        <v-col cols="12" class="text-center">
          <div class="sobre-label">QUEM FUNDOU</div>
          <h2 class="section-title">Os fundadores</h2>
          <p class="section-sub">Duas pessoas com um objetivo em comum: simplificar a gestão do transporte.</p>
        </v-col>
      </v-row>

      <v-row justify="center">

        <!-- José Gabriel -->
        <v-col cols="12" sm="6" md="4" class="mb-6">
          <div class="founder-card">
            <div class="founder-avatar green-avatar">
              <v-icon color="#10b981" size="52">mdi-account-circle-outline</v-icon>
            </div>
            <div class="founder-name">José Gabriel</div>
            <div class="founder-role">Co-fundador & Tecnologia</div>
            <v-divider class="founder-divider" />
            <p class="founder-bio">
              Responsável pelo desenvolvimento do sistema, José Gabriel uniu experiência
              técnica com a realidade das transportadoras para construir uma plataforma
              que realmente funciona no dia a dia.
            </p>
            <div class="founder-tags">
              <span class="tag">Desenvolvimento</span>
              <span class="tag">Produto</span>
              <span class="tag">Inovação</span>
            </div>
          </div>
        </v-col>

        <!-- Flávia Cristina -->
        <v-col cols="12" sm="6" md="4" class="mb-6">
          <div class="founder-card founder-card-purple">
            <div class="founder-avatar purple-avatar">
              <v-icon color="#a78bfa" size="52">mdi-account-circle-outline</v-icon>
            </div>
            <div class="founder-name">Flávia Cristina</div>
            <div class="founder-role">Co-fundadora & Operações</div>
            <v-divider class="founder-divider" />
            <p class="founder-bio">
              Com visão de negócio e proximidade ao setor de transporte, Flávia trouxe
              a perspectiva prática de quem conhece os desafios reais das pequenas
              e médias transportadoras.
            </p>
            <div class="founder-tags">
              <span class="tag tag-purple">Operações</span>
              <span class="tag tag-purple">Estratégia</span>
              <span class="tag tag-purple">Gestão</span>
            </div>
          </div>
        </v-col>

      </v-row>
    </v-container>

    <!-- DIVISOR -->
    <v-divider class="page-divider mx-auto" style="max-width:900px" />

    <!-- NÚMEROS -->
    <v-container class="py-16">
      <v-row justify="center" class="mb-10">
        <v-col cols="12" class="text-center">
          <div class="sobre-label">EM NÚMEROS</div>
          <h2 class="section-title">Nossa abrangência</h2>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="6" md="3" class="text-center mb-6" v-for="(stat, i) in stats" :key="i">
          <div class="stat-card">
            <v-icon :color="stat.cor" size="32" class="mb-3">{{ stat.icone }}</v-icon>
            <div class="stat-valor">{{ stat.valor }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- DIVISOR -->
    <v-divider class="page-divider mx-auto" style="max-width:900px" />

    <!-- ORIGEM -->
    <v-container class="py-16">
      <v-row justify="center" align="center">
        <v-col cols="12" md="6" class="mb-8 mb-md-0">
          <div class="sobre-label">ONDE TUDO COMEÇOU</div>
          <h2 class="section-title">Bela Vista, Goiás</h2>
          <p class="origem-text">
            A CargasZap nasceu em Bela Vista — GO, uma cidade do interior goiano que conhece
            de perto o peso e a importância do transporte rodoviário para o desenvolvimento
            do Brasil Central.
          </p>
          <p class="origem-text">
            Da cidade para o país. Hoje nosso foco é atender transportadoras em
            <strong>todo o território nacional</strong>, levando tecnologia simples e
            acessível de norte a sul do Brasil.
          </p>
          <div class="origem-badge mt-6">
            <v-icon color="#10b981" class="mr-2">mdi-map-marker-outline</v-icon>
            Bela Vista — GO &nbsp;|&nbsp;
            <v-icon color="#10b981" class="mx-2">mdi-earth</v-icon>
            Todo o Brasil
          </div>
        </v-col>

        <v-col cols="12" md="5" class="d-flex justify-center">
          <div class="mapa-card">
            <v-icon color="#10b981" size="96">mdi-map-outline</v-icon>
            <div class="mapa-label">Brasil inteiro</div>
            <div class="mapa-sub">Atendimento nacional</div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- CTA FINAL -->
    <div class="sobre-cta">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="7" class="text-center">
            <h2 class="cta-title">Faça parte dessa história</h2>
            <p class="cta-sub">
              Junte-se às transportadoras que já simplificaram sua gestão com o CargasZap.
            </p>
            <v-btn
              large rounded color="#10b981"
              class="white--text font-weight-bold mt-4 glow-btn mr-4"
              to="/cadastro"
            >
              Testar Gratis
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
            <v-btn
              large rounded outlined color="#10b981"
              class="font-weight-bold mt-4"
              @click="$router.push({ name: 'site' })"
            >
              Conhecer o sistema
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>

  </v-container>
</template>

<script>
export default {
  name: "SobrePage",

  data() {
    return {
      valores: [
        { icone: 'mdi-lightbulb-outline',       cor: '#f59e0b', titulo: 'Simplicidade',   desc: 'Interface clara, sem treinamento longo' },
        { icone: 'mdi-handshake-outline',        cor: '#10b981', titulo: 'Praticidade',    desc: 'Tudo que precisa, nada que atrapalha' },
        { icone: 'mdi-whatsapp',                 cor: '#22c55e', titulo: 'Integração',     desc: 'WhatsApp no centro da operação' },
        { icone: 'mdi-shield-check-outline',     cor: '#3b82f6', titulo: 'Confiança',      desc: 'Seus dados protegidos e seguros' },
      ],
      stats: [
        { icone: 'mdi-map-marker-radius-outline', cor: '#10b981', valor: 'Nacional',   label: 'Abrangência' },
        { icone: 'mdi-truck-outline',             cor: '#f59e0b', valor: 'Qualquer',   label: 'Tipo de transportadora' },
        { icone: 'mdi-whatsapp',                  cor: '#22c55e', valor: '24h',        label: 'Alertas automáticos' },
        { icone: 'mdi-clock-fast',                cor: '#a78bfa', valor: '2024',       label: 'Ano de fundação' },
      ]
    };
  }
};
</script>

<style scoped>
.sobre-page {
  background: radial-gradient(circle at top left, #0f172a, #020617);
  min-height: 100vh;
  color: #f1f5f9;
  font-family: "Inter", sans-serif;
}

/* HERO */
.sobre-hero {
  position: relative;
  padding: 100px 0 80px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  overflow: hidden;
}

.hero-glow {
  position: absolute;
  top: -200px;
  left: 50%;
  transform: translateX(-50%);
  width: 700px;
  height: 700px;
  background: radial-gradient(circle, rgba(16,185,129,0.12) 0%, transparent 70%);
  filter: blur(80px);
  pointer-events: none;
}

.sobre-label {
  color: #10b981;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 12px;
}

.sobre-hero-title {
  font-size: 46px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 20px;
}

.highlight { color: #10b981; }

.sobre-hero-sub {
  color: #94a3b8;
  font-size: 17px;
  max-width: 580px;
  margin: 0 auto;
  line-height: 1.7;
}

/* MISSÃO */
.missao-card {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(16,185,129,0.2);
  border-radius: 20px;
  padding: 36px;
}

.missao-icon-wrap {
  width: 72px;
  height: 72px;
  background: rgba(16,185,129,0.08);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.missao-title {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 16px;
  color: #f1f5f9;
}

.missao-text {
  color: #94a3b8;
  font-size: 15px;
  line-height: 1.8;
  margin-bottom: 12px;
}

/* VALORES */
.valor-card {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 14px;
  padding: 20px 16px;
  height: 100%;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.valor-card:hover {
  border-color: #10b981;
  box-shadow: 0 0 20px rgba(16,185,129,0.1);
}

.valor-titulo {
  font-size: 14px;
  font-weight: 700;
  color: #f1f5f9;
  margin-bottom: 6px;
}

.valor-desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

/* SECTION TITLES */
.section-title {
  font-size: 32px;
  font-weight: 800;
  color: #f1f5f9;
  margin-bottom: 10px;
}

.section-sub {
  color: #94a3b8;
  font-size: 15px;
}

/* FUNDADORES */
.founder-card {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(16,185,129,0.2);
  border-radius: 20px;
  padding: 36px 28px;
  text-align: center;
  height: 100%;
  transition: box-shadow 0.2s;
}

.founder-card:hover {
  box-shadow: 0 0 40px rgba(16,185,129,0.1);
}

.founder-card-purple {
  border-color: rgba(167,139,250,0.25);
}

.founder-card-purple:hover {
  box-shadow: 0 0 40px rgba(167,139,250,0.12);
}

.founder-avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.green-avatar  { background: rgba(16,185,129,0.1);  border: 2px solid rgba(16,185,129,0.3); }
.purple-avatar { background: rgba(167,139,250,0.1); border: 2px solid rgba(167,139,250,0.3); }

.founder-name {
  font-size: 20px;
  font-weight: 800;
  color: #f1f5f9;
  margin-bottom: 4px;
}

.founder-role {
  font-size: 13px;
  color: #10b981;
  font-weight: 600;
  margin-bottom: 16px;
}

.founder-divider {
  border-color: rgba(255,255,255,0.06) !important;
  margin-bottom: 16px;
}

.founder-bio {
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.7;
  margin-bottom: 16px;
}

.founder-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
}

.tag {
  background: rgba(16,185,129,0.1);
  color: #10b981;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  border: 1px solid rgba(16,185,129,0.2);
}

.tag-purple {
  background: rgba(167,139,250,0.1);
  color: #a78bfa;
  border-color: rgba(167,139,250,0.2);
}

/* STATS */
.stat-card {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 16px;
  padding: 28px 16px;
  transition: border-color 0.2s;
}

.stat-card:hover {
  border-color: #10b981;
}

.stat-valor {
  font-size: 30px;
  font-weight: 800;
  color: #f1f5f9;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #64748b;
}

/* ORIGEM */
.origem-text {
  color: #94a3b8;
  font-size: 15px;
  line-height: 1.8;
  margin-bottom: 12px;
}

.origem-text strong { color: #f1f5f9; }

.origem-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(16,185,129,0.08);
  border: 1px solid rgba(16,185,129,0.2);
  border-radius: 30px;
  padding: 10px 20px;
  color: #94a3b8;
  font-size: 14px;
}

.mapa-card {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(16,185,129,0.15);
  border-radius: 24px;
  width: 260px;
  height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 0 60px rgba(16,185,129,0.07);
}

.mapa-label {
  font-size: 20px;
  font-weight: 800;
  color: #f1f5f9;
}

.mapa-sub {
  font-size: 13px;
  color: #64748b;
}

/* CTA */
.sobre-cta {
  background: linear-gradient(180deg, transparent 0%, #0b1220 100%);
  padding: 80px 0;
  border-top: 1px solid rgba(255,255,255,0.05);
}

.cta-title {
  font-size: 34px;
  font-weight: 800;
  color: #f1f5f9;
  margin-bottom: 12px;
}

.cta-sub {
  color: #94a3b8;
  font-size: 16px;
}

.glow-btn {
  box-shadow: 0 0 20px rgba(16,185,129,0.4);
}

.page-divider {
  border-color: rgba(255,255,255,0.06) !important;
  display: block;
}

@media (max-width: 600px) {
  .sobre-hero-title { font-size: 30px; }
  .section-title    { font-size: 24px; }
  .cta-title        { font-size: 24px; }
}
</style>